/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-16 17:00:29
 * @FilePath: /app-monorepo-projects/packages/app-share/src/services/fetch-collection-feeds/index.ts
 */
import { loadWslAjaxAsync } from '@/utils/load-wslib';
import { formatFeed, formatCollectionInfo } from '@/utils/formatter';
import { TRPC_CALL_PATH } from '@/constants/url';
import { ModelCollectionInfo, ModelMetaFeed } from '@/types/model';
import { FetchCollectionFeedsReq, FetchCollectionFeedsRsp } from '@/types/services/fetch-collection-feeds';

type FetchResult = {
  collection: null | ModelCollectionInfo,
  feedList: ModelMetaFeed[],
};

/**
 *
 * csr阶段获取合集的feed流
 * @export
 * @param
 * @return {*}  {(Promise<FetchResult | null>)}
 */
export async function fetchCollectionFeedsCSR(params: FetchCollectionFeedsReq): Promise<FetchResult> {
  const fetchConfig = {
    url: `${TRPC_CALL_PATH}/WSGetCollectionFeedList`,
    withCredentials: true,
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    responseType: 'json',
    data: JSON.stringify({
      req_header: {},
      req_body: {
        feedId: params.feedId,
        cid: params.collectionId,
        sceneId: '6', // 端外分享场景
      },
    }),
  };
  let collection = null;
  let feedList: ModelMetaFeed[] = [];
  const wslAjax = await loadWslAjaxAsync();
  if (!wslAjax) return { collection, feedList };
  try {
    const { request } = wslAjax;
    const res = await request<FetchCollectionFeedsRsp>(fetchConfig);
    feedList = (res?.rsp_body?.feedList || []).map((item, index) => formatFeed(item.feed, index));
    collection = formatCollectionInfo(res?.rsp_body?.collection);
  } catch (err) {
    console.error('接口fetchCollectionFeeds出现了一些问题');
  }
  return { collection, feedList };
}
